import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import {
    buildGraphQLParams,
    convertCouponListingToAReadableFormat,
    convertDataToListingDisplay,
    getGraphQLTotalRecords,
    buildElasticGraphQLParams,
} from '../selectors/converterSelector';
import config from '../store/_config';
import { getSelectedItems } from '../selectors/converterSelector';
import pluralize from 'pluralize';
import {
    createModal,
    hideModal,
} from '../dom/components/confirm-removal-modal';

export const toggleLoading = (key, value) => {
    return {
        type: 'TOGGLE_COUPON_LOADING',
        key: key,
        value: value,
    };
};
export const replaceCouponListDisplay = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_COUPON_LIST_DISPLAY',
            value: value,
        });

        dispatch(resetCouponSelectedRows(false));
    };
};
export const updateCouponList = (value) => {
    return {
        type: 'UPDATE_COUPON_LIST',
        value: value,
    };
};
export const updateCouponListFilters = () => {
    return (dispatch, getState) => {
        const state = getState();
        const { selectedCategory } = state.coupon.filterForm;

        const filterData = {
            CategoryID: selectedCategory,
        };

        if (selectedCategory == 0) {
            delete filterData.CategoryID;
        }

        dispatch({
            type: 'UPDATE_COUPON_LIST_FILTERS',
            value: filterData,
        });

        dispatch(requestCoupons());
    };
};
export const updateCouponListFilterForm = (key, value) => {
    return {
        type: 'UPDATE_COUPON_FILTER_FORM_DATA',
        key: key,
        value: value,
    };
};
export const setActivePage = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_COUPON_LIST_ACTIVE_PAGE',
            value: value,
        });

        dispatch(requestCoupons());
    };
};
export const updateCouponListParams = (tableState, tableInstance) => {
    return (dispatch, getState) => {
        const state = getState();
        const { sortBy, sortDirection } = state.coupon.listParams;
        const { sorted } = tableState;

        if (sorted.length) {
            const newSortBy = sorted[0].id;
            const newSortDirection = sorted[0].desc ? 'DESC' : 'ASC';

            if (sortBy != newSortBy || sortDirection != newSortDirection) {
                dispatch(setSort(newSortBy, newSortDirection));
            }
        } else {
            if (!(sortBy == '' && sortDirection == '')) {
                dispatch(setSort('', ''));
            }
        }
    };
};
export const setTotalRecords = (value) => {
    return {
        type: 'SET_COUPON_LIST_TOTAL_RECORDS',
        value: value,
    };
};
export const setSort = (sortBy, sortDirection) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_COUPON_LIST_SORT',
            value: sortBy,
            direction: sortDirection,
        });

        dispatch(requestCoupons());
    };
};
export const updateCouponAllCheckboxesValue = () => {
    return (dispatch, getState) => {
        const state = getState();
        const currentSelectedValue = state.coupon.allCheckboxesSelected;
        const list = Object.entries(state.coupon.selected);
        let finalSelectedValue = list.length > 0 ? true : false;

        list.map(([id, value]) => {
            if (value === false) {
                finalSelectedValue = value;
            }
        });

        if (finalSelectedValue !== currentSelectedValue) {
            dispatch({
                type: 'UPDATE_COUPON_ALL_ROWS_CHECKBOX',
                value: finalSelectedValue,
            });
        }
    };
};
export const updateCouponAllSelectedRows = (value) => {
    return (dispatch, getState) => {
        const state = getState();
        const list = state.coupon.list;
        let selected = {};

        Object.keys(list).map((id) => {
            selected[id] = value;
        });

        dispatch({
            type: 'REPLACE_COUPON_SELECTED_ROWS',
            value: selected,
        });

        dispatch(updateCouponAllCheckboxesValue());
    };
};
export const updateCouponSelectedRow = (key, value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_COUPON_SELECTED_ROW',
            key: key,
            value: value,
        });

        dispatch(updateCouponAllCheckboxesValue());
    };
};
export const resetCouponSelectedRows = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'RESET_COUPON_SELECTED_ROWS',
        });

        dispatch(updateCouponAllCheckboxesValue());
    };
};
export const requestCoupons = () => {
    return (dispatch, getState) => {
        const state = getState();

        let { url, query } = config.coupon.listing;
        query = query.replace(
            /{params}/,
            buildGraphQLParams(state.coupon.listParams)
        );

        dispatch(toggleLoading('list', true));

        return axios
            .get(url, {
                withCredentials: true,
                params: {
                    query: query,
                },
            })
            .then((response) => {
                const list = convertCouponListingToAReadableFormat(
                    response.data.data.readAllCoupons
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readAllCoupons,
                    'ID'
                );
                const total = getGraphQLTotalRecords(
                    response.data.data.readAllCoupons
                );

                // wait for async requests
                Promise.all([
                    dispatch(replaceCouponListDisplay(listingDisplay)),
                    dispatch(updateCouponList(list)),
                    dispatch(setTotalRecords(total)),
                ]).then(() => {
                    dispatch(toggleLoading('list', false));
                });
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const showRemoveItemConfirmationModal = () => {
    return (dispatch, getState) => {
        const state = getState();
        const selected = getSelectedItems(
            state.coupon.list,
            state.coupon.selected
        );

        const modalName = 'confirm-remove-coupon-items-modal';
        let data = {
            heading: 'Proceed with removal?',
            noticeText: `Are you sure you want to remove ${pluralize(
                'coupon',
                selected.length,
                true
            )}?`,
            content: '',
        };

        // create modal
        createModal(modalName, data, function () {
            hideModal(modalName);
            dispatch(deleteSelectedCoupons());
        });
    };
};
export const deleteSelectedCoupons = () => {
    return (dispatch, getState) => {
        const state = getState();

        const selectedIDs = Object.entries(state.coupon.selected).map(
            ([id, status]) => {
                if (status === true) {
                    return id;
                }
            }
        );

        if (!selectedIDs.length) {
            return;
        }

        dispatch(toggleLoading('list', true));

        return axiosDeleteCoupons(selectedIDs)
            .then((response) => {
                dispatch(requestCoupons());
            })
            .catch((error) => {
                dispatch(toggleLoading('list', false));
            });
    };
};
export const axiosDeleteCoupons = (selectedIDs) => {
    let { url, query } = config.coupon.delete;
    let data = {
        id: query,
        variables: {
            ID: selectedIDs,
        },
    };

    return axios
        .post(url, data, {
            withCredentials: true,
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};
export const axiosSubmitCoupon = (formData) => {
    let { url, query } = config.coupon.create;

    if (typeof formData.ID != 'undefined') {
        delete formData.ID;
    }

    let data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    return axios
        .post(url, data, {
            withCredentials: true,
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};
export const axiosGenerateCouponCode = () => {
    let { url, query } = config.coupon.generateCode;

    let data = {
        id: query,
    };

    return axios
        .post(url, data, {
            withCredentials: true,
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};
export const axiosApplyCoupon = (couponCode) => {
    let { url, query } = config.coupon.apply;

    let data = {
        id: query,
        variables: {
            Code: couponCode,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};

export const axiosMaximumCouponDiscount = () => {
    let { url, query } = config.coupon.calculateMaximumDiscount;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosAllProductsForCoupon = (params) => {

    let { url, query } = config.coupon.productListing;
    query = query.replace(
        /{params}/,
        buildElasticGraphQLParams(params)
    );

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
